import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'phoneNumberFormat',
})
export class PhoneNumberFormatPipe implements PipeTransform {
  spaceArray = [3, 6, 10];

  transform(value: string, ...args: unknown[]): string {
    if (value.startsWith('06')) {
      value.replace(/^.{2}/g, '+36');
    }
    if (value.startsWith('0036')) {
      value.replace(/^.{4}/g, '+36');
    }
    if (value.length === 12) {
      this.spaceArray.forEach((spaceIndex) => {
        value = value.substring(0, spaceIndex) + ' ' + value.substring(spaceIndex);
      });
      return value;
    }
    return value;
  }
}
